import { render } from "./Web.vue?vue&type=template&id=7dc7a0d0&scoped=true"
import script from "./Web.vue?vue&type=script&lang=js"
export * from "./Web.vue?vue&type=script&lang=js"

import "./Web.vue?vue&type=style&index=0&id=7dc7a0d0&scoped=true&lang=css"
import "./Web.vue?vue&type=style&index=1&id=7dc7a0d0&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dc7a0d0"]])

export default __exports__